/**
 * UTM Tagger
 *
 * Captures UTM parameters from Meta (Facebook/Instagram) ad URLs
 * and injects them as customer tags on Shopify forms.
 *
 * Cookie: _lumay_utm (JSON, 180-day expiry)
 * Tag format: utm_source-facebook, utm_campaign-summer_sale
 *
 * Target forms:
 *   - create_customer (registration): injects customer[tags] hidden field
 *   - contact[tags] (newsletter, restock): appends to existing value
 *
 * Zero dependencies. Loaded with defer in theme.liquid.
 */

(function () {
  'use strict';

  var COOKIE_NAME = '_lumay_utm';
  var COOKIE_DAYS = 180;
  var UTM_KEYS = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content'];

  // ── Cookie helpers ──────────────────────────────────────────────

  function getCookie(name) {
    var matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; expires=' + expires.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  // ── Capture: read URL params → save cookie ─────────────────────

  function captureUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    var hasAny = false;

    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        utm[key] = value;
        hasAny = true;
      }
    });

    if (hasAny) {
      setCookie(COOKIE_NAME, JSON.stringify(utm), COOKIE_DAYS);
    }
  }

  // ── Inject: read cookie → append tags to forms ─────────────────

  function buildTagString(utm) {
    var tags = [];
    UTM_KEYS.forEach(function (key) {
      if (utm[key]) {
        tags.push(key + '-' + utm[key]);
      }
    });
    return tags.join(',');
  }

  function injectUtmTags() {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return;

    var utm;
    try {
      utm = JSON.parse(raw);
    } catch (e) {
      return;
    }

    var tagString = buildTagString(utm);
    if (!tagString) return;

    // Registration form: inject new hidden field
    var registerForm = document.querySelector('.login__form form[action*="/account"]');
    if (registerForm && !registerForm.querySelector('input[name="customer[tags]"]')) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'customer[tags]';
      input.value = tagString;
      registerForm.appendChild(input);
    }

    // Contact forms with existing contact[tags]: append to value
    var contactTagInputs = document.querySelectorAll('input[name="contact[tags]"]');
    contactTagInputs.forEach(function (input) {
      var current = input.value;
      input.value = current ? current + ',' + tagString : tagString;
    });
  }

  // ── Init ────────────────────────────────────────────────────────

  captureUtmParams();
  document.addEventListener('DOMContentLoaded', injectUtmTags);
})();
